import {Card, Stack, styled, Typography} from '@mui/material';

const StyledCard = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	height: 100%;
	box-shadow: none;
	border: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

const StyledDataContent = styled(Stack)`
	padding: 12px 16px;
	padding-block: 8px;
	flex: 1;
	width: 100%;
	gap: 8px;
`;

const StyledHeaderContainer = styled(Stack)`
	width: 100%;
	flex-direction: column;
	padding: 12px 16px;
	border-bottom: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

const StyledTitle = styled(Typography)`
	font-size: 18px;
`;

export {StyledCard, StyledDataContent, StyledHeaderContainer, StyledTitle};
